import React, { Fragment } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box, Card, CardActionArea, Typography } from '@material-ui/core'

import useStyles from './styles'
import theme from 'theme'

const DashboardTabs = ({ onChange, currentTab, tabs }) => {
  const classes = useStyles()

  return (
    <PerfectScrollbar
      options={{ suppressScrollY: true }}
      style={{ maxWidth: '100%' }}
    >
      <Box className={classes.container} pb={2}>
        {tabs.map((tab, index) => {
          const Icon = tab.Icon || Fragment

          const selected = currentTab === tab.value

          return (
            <Card
              key={index}
              className={clsx(classes.card, {
                [classes.selected]: selected,
              })}
            >
              <CardActionArea onClick={() => onChange(tab.value)}>
                <Box
                  display="flex"
                  alignItems="center"
                  gridGap={theme.spacing(1)}
                  px={2}
                  py={1}
                >
                  <Icon size={20} className={classes.icon} />
                  <Typography variant="h6" className={classes.label}>
                    {tab.label}
                  </Typography>
                </Box>
              </CardActionArea>
            </Card>
          )
        })}
      </Box>
    </PerfectScrollbar>
  )
}

DashboardTabs.propTypes = {
  onChange: PropTypes.func.isRequired,
  currentTab: PropTypes.string.isRequired,
  tabs: PropTypes.array.isRequired,
}

export default DashboardTabs
